import { format } from "date-fns";

function DateRangeDate({ date }: { date: Date }) {
  return (
    <span className="font-medium underline decoration-dashed decoration-blue-500 dark:decoration-blue-500">
      {format(date, "MMMM d, yyyy")}
    </span>
  );
}

export function DateRange({ range }: { range: [Date, Date] | null }) {
  if (!range) return null;

  const [min, max] = range;
  return (
    <div className="text-lg mb-5">
      Activity between <DateRangeDate date={min} /> and <DateRangeDate date={max} />
    </div>
  );
}
